// extracted by mini-css-extract-plugin
module.exports = {"answer-section":"answer-section_3xvQd","evaluation-wrapper":"evaluation-wrapper_1ky3J"};